import alg1 from '../img/subject_icons/Alg1.svg'
import alg2 from '../img/subject_icons/Alg2.svg'
import astronomy from '../img/subject_icons/Astronomy.svg'
import at from '../img/subject_icons/AT.svg'
import geometry from '../img/subject_icons/Geometry.svg'
import earthScience from '../img/subject_icons/EarthScience.svg'
import advBiology from '../img/subject_icons/AdvBio.svg'
import biology from '../img/subject_icons/Bio.svg'
import prelagebra from '../img/subject_icons/Prealgebra.svg'
import chem from '../img/subject_icons/Chem.svg'
import calc from '../img/subject_icons/Calc.svg'
import physics from '../img/subject_icons/Physics.svg'

import alg1_2 from '../img/subject_icons/Alg1-2.svg'
import alg2_2 from '../img/subject_icons/Alg2-2.svg'
import astronomy_2 from '../img/subject_icons/Astronomy-2.svg'
import at_2 from '../img/subject_icons/AT-2.svg'
import geometry_2 from '../img/subject_icons/Geometry-2.svg'
import earthScience_2 from '../img/subject_icons/EarthScience-2.svg'
import advBiology_2 from '../img/subject_icons/AdvBio-2.svg'
import biology_2 from '../img/subject_icons/Bio-2.svg'
import prelagebra_2 from '../img/subject_icons/Prealgebra-2.svg'
import chem_2 from '../img/subject_icons/Chem-2.svg'
import calc_2 from '../img/subject_icons/Calc-2.svg'
import physics_2 from '../img/subject_icons/Physics-2.svg'

const subjectToImage = {
  8951:prelagebra, //Math Foundations
  4106:alg1, //Algebra 1
  752:geometry, //Geometry
  4712:alg2, //Algebra 2
  1:calc, //Calculus
  5525:at, //Advanced Topics,
  9213:earthScience, //Earth Science
  10005:biology, //Biology
  7587:advBiology, //Advanced Biology
  7954:chem, //Chemistry
  1618:physics, //Physics
  1943:astronomy, //Astronomy
}
const subjectToImageLight = {
  8951:prelagebra_2, //Math Foundations
  4106:alg1_2, //Algebra 1
  752:geometry_2, //Geometry
  4712:alg2_2, //Algebra 2
  1:calc_2, //Calculus
  5525:at_2, //Advanced Topics,
  9213:earthScience_2, //Earth Science
  10005:biology_2, //Biology
  7587:advBiology_2, //Advanced Biology
  7954:chem_2, //Chemistry
  1618:physics_2, //Physics
  1943:astronomy_2, //Astronomy
}

export {subjectToImage, subjectToImageLight}


// WEBPACK FOOTER //
// ./src/core/less/SubjectToImage.js